import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { PopoverModule } from '../popover/popover.module';
import { TooltipTextComponent } from './tooltip-text.component';

@NgModule({
  declarations: [TooltipTextComponent],
  imports: [CommonModule, PopoverModule, SharedModule],
  exports: [TooltipTextComponent],
})
export class TooltipTextModule {}
